declare global {
  interface Window {
    ShowSpinner: () => void;
    HideSpinner: () => void;
    jsSaveAsFile: (fileName: string, base64Content: string) => void;
    UmeaUi: {
      autoSizeSelect: (el: HTMLSelectElement) => void;
    };
  }
}

window.ShowSpinner = function (): void {
  const divCoverSpin = document.getElementById("cover-spin");
  if (divCoverSpin) divCoverSpin.style.display = "block";
};

window.HideSpinner = function (): void {
  const divCoverSpin = document.getElementById("cover-spin");
  if (divCoverSpin) divCoverSpin.style.display = "none";
};

window.jsSaveAsFile = function (fileName: string, base64Content: string): void {
  const link = document.createElement("a");
  link.download = fileName;
  link.href = "data:application/octet-stream;base64," + base64Content;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/** Resize a <select> to fit its currently selected option text. */
function autoSizeSelect(el: HTMLSelectElement): void {
  const measure = document.createElement("span");
  measure.style.cssText =
    "position:absolute;visibility:hidden;white-space:nowrap;" +
    `font:${getComputedStyle(el).font}`;
  measure.textContent = el.options[el.selectedIndex]?.text ?? "";
  document.body.appendChild(measure);
  // padding-left(10) + padding-right(24) + chevron space + buffer
  el.style.width = `${measure.offsetWidth + 44}px`;
  document.body.removeChild(measure);
}

window.UmeaUi = {
  autoSizeSelect,
};

export {};
